/**
 * Star.Ryhwa Site Settings Configuration
 *
 * Easily toggle site-wide features and popups here.
 */

export const SITE_SETTINGS = {
  // Master toggle: Set to false to hide the popup completely
  showUnderConstructionPopup: true,

  // Popup content
  popup: {
    title: "Store Launching Soon",
    message:
      "We're currently preparing our shop for official launch. Follow us on Instagram for drop announcements, or take a look around the store in preview mode.",
    instagramHandle: "@star.ryhwa",
    instagramUrl: "https://www.instagram.com/star.ryhwa?igsh=NTc4MTIwNjQ2YQ==",
    buttonText: "Preview Store",
  },

  // Storage key to prevent annoying repeat popups within the same session
  storageKey: "starryhwa_seen_construction_popup",
};
